import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { TokenStorageService } from '../_services/token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class NoLoginGuard implements CanActivate {

  constructor(
    private router: Router,
    private tokenservice: TokenStorageService) {
  }
  isLoggedIn = false;
  canActivate(route: ActivatedRouteSnapshot,state: RouterStateSnapshot) {
    const pending2FA = this.tokenservice.isPending2FAEnrollment();
    this.isLoggedIn = !!this.tokenservice.getToken();
    if (this.isLoggedIn && pending2FA) {
      return true;
    }
    if (this.isLoggedIn) {
      this.router.navigate(['admin'], { queryParams: { returnUrl: state.url } });
      return false;
    }
    return true;
  }
}

